import { render, staticRenderFns } from "./DefectsEdit.vue?vue&type=template&id=78f0e2d0&scoped=true&"
import script from "./DefectsEdit.vue?vue&type=script&lang=js&"
export * from "./DefectsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f0e2d0",
  null
  
)

export default component.exports